import { useEffect, useState } from "react";
import { fmtEth, fmtUsd } from "../../lib/api";

const Stat = ({ label, value, sub, testId, highlight }) => (
  <div className={`card-surface rounded-xl p-6 ${highlight ? "border-t-2 border-t-[#00C805]" : ""}`}>
    <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">{label}</p>
    <p data-testid={testId} className="font-mono font-semibold text-xl mt-2 text-white">{value}</p>
    {sub && <p className="text-xs text-neutral-500 mt-1 font-mono">{sub}</p>}
  </div>
);

export const StatsBar = ({ stats, config }) => {
  const [secs, setSecs] = useState(null);

  useEffect(() => {
    if (stats?.seconds_until_next_cycle !== undefined && !stats.awaiting_deployment) {
      setSecs(stats.seconds_until_next_cycle);
    }
  }, [stats]);

  useEffect(() => {
    const t = setInterval(() => setSecs((s) => (s === null || s <= 0 ? s : s - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  const awaiting = !stats || stats.awaiting_deployment;
  const mm = secs !== null ? String(Math.floor(secs / 60)).padStart(2, "0") : "--";
  const ss = secs !== null ? String(secs % 60).padStart(2, "0") : "--";

  return (
    <section className="max-w-7xl mx-auto px-6 -mt-4 pb-8">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
        <div className="col-span-2 card-surface rounded-xl p-6 border-t-2 border-t-[#00C805] flex flex-col justify-between">
          <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">Next payout in</p>
          <p data-testid="countdown-timer" className="font-mono font-semibold text-5xl mt-2 text-[#00C805] glow-green">
            {mm}<span className="timer-colon">:</span>{ss}
          </p>
          {awaiting ? (
            <p data-testid="awaiting-deployment-badge" className="text-xs text-amber-400/80 mt-2 font-mono">Awaiting contract deployment</p>
          ) : (
            <p className="text-xs text-neutral-500 mt-2 font-mono">cycle #{(stats.cycle_count ?? 0) + 1}</p>
          )}
        </div>
        <Stat label="ETH queued this cycle" testId="stat-vault-pending"
          value={awaiting ? "—" : `${fmtEth(stats.vault_pending_eth)} ETH`}
          sub={awaiting ? "" : fmtUsd(stats.vault_pending_usd)} highlight />
        <Stat label="All-time distributed" testId="stat-total-distributed"
          value={awaiting ? "—" : `${fmtEth(stats.total_distributed_eth)} ETH`}
          sub={awaiting ? "" : fmtUsd(stats.total_distributed_usd)} />
        <Stat label="Eligible holders" testId="stat-holders" value={stats?.holder_count != null ? stats.holder_count.toLocaleString() : "—"} />
        <Stat label="Total claimed" testId="stat-claimed" value={awaiting ? "—" : `${fmtEth(stats.total_claimed_eth)} ETH`} />
      </div>
      {!awaiting && stats.last_cycle_tx && (
        <p className="mt-3 text-xs font-mono text-neutral-500">
          Last cycle:{" "}
          <a data-testid="last-cycle-tx-link" href={`${config?.explorer_url}/tx/${stats.last_cycle_tx}`} target="_blank" rel="noreferrer" className="text-[#00C805] hover:text-[#13D059] transition-colors duration-200">
            {stats.last_cycle_tx.slice(0, 18)}… ↗
          </a>
        </p>
      )}
    </section>
  );
};
